<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <router-view :key="key" />
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    key() {
      return this.$route.path;
    }
  }
};
</script>

<style lang="scss" scoped>

.app-main {
  display: block;
  /**
  background: #fff;
  */
  background-color: #F2F2F2;
  background-clip:content-box;
  min-height: $mainHei;
  padding-top: 0;
}
</style>
